<!-- 充值 -->
<template>
    <div class="topUp">
        <div class="tableConBox">
            <div class="tableTem">
                <div class="HSpace1">&nbsp;</div>
                <div class="searchBox flex flex-align-center">
                    <div class="searchCon clearfix" id="topUp-pc">
                        <div class="left invTopItem flex flex-align-center">
                            <span class="name">店铺名称</span>
                            <span class="num" v-text="storeData.name"></span>
                        </div>
                        <div class="left invTopItem flex flex-align-center">
                            <span class="name">当前版本</span>
                            <span class="num" v-text="storeLV[storeData.level]">基础版</span>
                        </div>
                        <div class="left invTopItem flex flex-align-center">
                            <span class="name">到期日期</span>
                            <span class="num" v-if="storeData.level!=='ONE'">{{storeData.expireTime | numberToAllDate('')}}</span>
                            <span class="num" v-else>无限</span>
                        </div>
                    </div>
                </div>
                <div class="HSpace2">&nbsp;</div>
                <div class="tableBox">
                    <div class="topUpItem clearfix">
                        <div class="name left">购买版本：</div>
                        <div class="hand left">
                           <span class="edition" @click="cutEdition('TWO')" :class="{'cur-edition':curLV=='TWO'}" v-if="storeData.level!='THREE'">基础版</span>
                           <span class="edition " @click="cutEdition('THREE')" :class="{'cur-edition':curLV=='THREE'||curLV=='ONE'}">高级版</span>
                           <span class="edition " @click="cutEdition('UP')" :class="{'cur-edition':curLV=='UP'}" v-if="storeData.level=='TWO'">升为高级</span>
                        </div>
                    </div>
                    <!-- <div class="topUpItem clearfix">
                        <div class="name left">购买时长:</div>
                        <div class="hand left">
                            <el-select v-model="value2" placeholder="默认一年">
                                <el-option
                                    v-for="item in options2"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value"
                                    :disabled="item.disabled">
                                </el-option>
                            </el-select> 
                        </div>
                    </div> -->
                    <div class="topUpItem clearfix">
                        <div class="name left">购买时长：</div>
                        <div class="hand left">
                           默认一年
                        </div>
                    </div>
                    <div class="topUpItem clearfix">
                        <div class="name left">单价（元/年）：</div>
                        <div class="hand left" style="color:#f76260;" v-text="curMoney[curLV]">
                           
                        </div>
                    </div>
                    <div class="topUpItem clearfix">
                        <div class="name left">选择支付方式：</div>
                        <div class="hand left">
                           <!-- <span :class="{pay1:!payType}" @click="choicePayType(false)">微信</span>
                           <span :class="{pay1:payType}" @click="choicePayType(true)">支付宝</span> -->
                            <el-radio class="radio" v-model="payType" label="false">微信</el-radio>
                            <el-radio class="radio" v-model="payType" label="true">支付宝</el-radio>
                        </div>
                        <div class="topUpItemBtn"> <el-button type="primary" @click="createdCode">充值续费</el-button></div>

                    </div>
                </div>
            </div>
        </div>
        <el-dialog
            title="升为高级版"
            :visible.sync="upLvBtn"
            size="tiny">
            <div id="topupQrcode">
               4545
            </div>
        </el-dialog>
        <el-dialog
            title="请扫描二维码支付"
            :visible.sync="addEmplVisible"
            size="tiny">
            <div id="topupQrcode">
                <div class="img" v-if="num<30">
                    <img :src="imgUrl" alt="">
                </div>
                <div class="expire" v-if="num==30">
                    <p class="position-middle-center">二维码已过期</p>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script type="text/javascript">
import {API_BASE_URL} from "./../../../urlConfig/index";
    export default{
        props: ['curStoreId','pageSize','storeData'],
    	data () {
    		return {
                addEmplVisible: false,
                imgUrl:'',//支付二维码
                payType:'false',
                scanId:'',//轮询id
                num:0,//控制待支付时间
                storeLV:{
                    'ONE':"免费版",
                    'TWO':"基础版",
                    'THREE':"高级版",
                },
                LV:'',
                curMoney:{
                    'ONE':"0.00",
                    'TWO':"1200.00",
                    'THREE':"3200.00",
                    'UP':"2000.00",
                },
                curLV:this.storeData.level,//当前预付费版本
                upLvBtn:false,
    		}
    	},
        watch:{
            payType(val){
            }
        },
        methods: {
            //切换版本
            cutEdition(lv){
                this.curLV = lv;
            },
            //生成二维码
            createdCode() {
                let lv={
                    'ONE':"",
                    'TWO':"SECOND_LEVEL",
                    'THREE':"THREE_LEVEL",
                    'UP':"UPGRADE",
                };
                this.$http.get(API_BASE_URL+'v1/pay/web/scan-code?storeId='+this.curStoreId+'&type='+this.payType+'&rechargeType='+lv[this.curLV]).then((res)=>{
                    this.imgUrl = res.data.url;
                    this.addEmplVisible = true;
                    this.scanId = res.data.id;
                    this.getTopUpData();
                })
            },
            //轮询
            getTopUpData() {
                this.$http.get(API_BASE_URL+'v1/pay/scan-code/web-query?id='+this.scanId).then((res)=>{
                    if(res.status==202){
                        if(!this.addEmplVisible){
                            return;
                        }
                        setTimeout(()=>{
                            this.num++;
                            if(this.num>=30){
                                this.$message({
                                    message: '二维码过期',
                                    customClass: 'error'
                                });
                                return;
                            }
                            this.getTopUpData();
                        },2000)
                    }else if(res.status==200){
                        this.addEmplVisible = false;
                        this.$message({
                            message: '支付成功',
                            customClass: 'success'
                        })
                    }
                })
            }
        },
        created: function () {
        },
        mounted: function () {
            if(this.storeData.level){
               if(this.storeData.level=='ONE'||this.storeData.level=='TWO'){
                    this.curLV = 'THREE';
                }else{
                    this.curLV = this.storeData.level;
                }
            }else{
                this.$http.get('/stores/'+this.curStoreId).then((res)=>{
                    this.storeData = res.data;
                    if(this.storeData.level=='ONE'||this.storeData.level=='TWO'){
                        this.curLV = 'THREE';
                    }else{
                        this.curLV = this.storeData.level;
                    }
                });
            }
            // 改变关闭样式
            $(document).ready(()=>{
                $('.el-dialog__headerbtn i').attr('class', 'el-dialog__close iconfont icon-guanbi');
            });
        }
    }
</script>
<style lang="scss">
    @import '../../../../static/css/common.scss';
    @import '../../tableTemplate/tableTem.scss';
    // @import '../../tableTemplate/el-dialog.scss';
	@import "topUp";
</style>



// WEBPACK FOOTER //
// topUp.vue?5d9205da